/* eslint-disable */
$(function() {
  const maxPackSize = 54;
  let addToCartItems = [];

  const liveBuildBoxProducts = {
    blackcurrant: {
      1: {
        variantId: 39845937741986,
        ...blackCurrantSub,
      },
      2: {
        variantId: 39845937741986,
        ...blackCurrantSub,
      },
      3: {
        variantId: 39845937741986,
        ...blackCurrantSub,
      },
      4: {
        variantId: 39856734765218,
        ...blackCurrantSub,
      },
      5: {
        variantId: 39856734765218,
        ...blackCurrantSub,
      },
      6: {
        variantId: 39856741482658,
        ...blackCurrantSub,
      },
      7: {
        variantId: 39856741482658,
        ...blackCurrantSub,
      },
      8: {
        variantId: 39856746168482,
        ...blackCurrantSub,
      },
      9: {
        variantId: 39856746168482,
        ...blackCurrantSub,
      },
      10: {
        variantId: 39856746168482,
        ...blackCurrantSub,
      },
    },
    lemon: {
      1: {
        variantId: 39856776118434,
        ...lemonSub,
      },
      2: {
        variantId: 39856776118434,
        ...lemonSub,
      },
      3: {
        variantId: 39856776118434,
        ...lemonSub,
      },
      4: {
        variantId: 39845946327202,
        ...lemonSub,
      },
      5: {
        variantId: 39845946327202,
        ...lemonSub,
      },
      6: {
        variantId: 39856744136866,
        ...lemonSub,
      },
      7: {
        variantId: 39856744136866,
        ...lemonSub,
      },
      8: {
        variantId: 39856746692770,
        ...lemonSub,
      },
      9: {
        variantId: 39856746692770,
        ...lemonSub,
      },
      10: {
        variantId: 39856746692770,
        ...lemonSub,
      },
    },
    strawberry: {
      1: {
        variantId: 39856792043682,
        ...strawSub,
      },
      2: {
        variantId: 39856792043682,
        ...strawSub,
      },
      3: {
        variantId: 39856792043682,
        ...strawSub,
      },
      4: {
        variantId: 39845939773602,
        ...strawSub,
      },
      5: {
        variantId: 39845939773602,
        ...strawSub,
      },
      6: {
        variantId: 39856743219362,
        ...strawSub,
      },
      7: {
        variantId: 39856743219362,
        ...strawSub,
      },
      8: {
        variantId: 39856747217058,
        ...strawSub,
      },
      9: {
        variantId: 39856747217058,
        ...strawSub,
      },
      10: {
        variantId: 39856747217058,
        ...strawSub,
      },
    },
  };

  const buildBoxPrices = [
    "6.49",
    "6.49",
    "6.49",
    "5.84",
    "5.84",
    "5.65",
    "5.65",
    "5.52",
    "5.52",
    "5.52",
  ];

  let buildBoxProducts = {};

  buildBoxProducts = { ...liveBuildBoxProducts };

  const uniquePrices = 10;

  const localeOptions = {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  let isSubscriptionOrder = true;
  let builderHasItems = true;

  // Listen for click on any incrementors + change relevant input value accordingly
  $(".build-box__incrementor").click(function(e) {
    e.preventDefault();

    const minVal = 0;
    const maxVal = maxPackSize;
    let totalVal = 0;

    // Find the input that's relevant for the clicked incrementor
    //const input = $(this).siblings('input')[0];
    const input = $(this).siblings(".build-box__incrementor--input");

    // Assign whether the click was for a plus or minus
    const dataType = $(this).attr("data-type");

    // Assign current value of input
    const currentVal = parseInt(input.val());

    // Loop all inputs to find the current total packs selected (before we add or minus one from the click)
    // We do this because we only allow the eventual value change if it's within the parameters of minVal and maxVal
    $(".build-box__incrementor--input").each(function() {
      let newVal = parseInt($(this).val());
      totalVal = totalVal + newVal;
    });

    // Up the value if it doesn't go over maxVal
    //if(totalVal < maxVal) {
    if (dataType == "plus") {
      //if(currentVal < maxVal){
      input.val(currentVal + 1).change();
      //}
    }
    //}

    // Lower the value if it doesn't go under minVal
    if (dataType == "minus") {
      if (currentVal > minVal) {
        input.val(currentVal - 1).change();
      }
    }

    updateTotals();
  });

  const updateTotals = () => {
    let totalBoxItems = 0;

    // Loop inputs and add up total amount of items in box
    $(".build-box__incrementor--input").each(function() {
      let newVal = parseInt($(this).val());
      totalBoxItems = totalBoxItems + newVal;
    });

    // Function to display the amount of packs in the current box
    const totalBoxItemsContent = (totalBoxItems) => {
      console.log(totalBoxItems);
      if (totalBoxItems === 1) {
        return totalBoxItems + " pack";
      } else {
        return totalBoxItems + " packs";
      }
    };

    console.log("how many? " + totalBoxItems);
    $(".oneTimeCount").html(totalBoxItems);

    // Bail if there's no selected products, disable button and set price figures to £0
    if (totalBoxItems === 0) {
      builderHasItems = false;
      document
        .getElementById("addToCartButton")
        .classList.add("disabled_button");
      $("#buildBoxTotalCost").html(
        '<span class="now-price">£0.00</span><span class="was-price grey">You Saved £0.00</span></p>'
      );
      $(".oneTimeServing").html("£0.00");
      $(".subServing").html("£0.00");
      $(".oneTimeCount").html("0");
      $(".subCount").html("0");
      $(".now-price").html("£0.00");
      $("#buildBoxPacksInBox").html(totalBoxItemsContent(totalBoxItems));
      $(".onetime_incentive").html("Buy 4 tubes or more & save 10%");
      $(".sub_incentive").html(
        "Add 2 or more products to subscribe & save 20%"
      );
      return;
    } else if (totalBoxItems >= 1) {
      $(".onetime_incentive").html(
        "Add " + (4 - totalBoxItems) + " more and pay £5.84 per tube"
      );
    }
    if (totalBoxItems >= 4 && totalBoxItems < 6) {
      $(".onetime_incentive").html(
        "Add " + (6 - totalBoxItems) + " more and pay £5.65 per tube"
      );
    }
    if (totalBoxItems >= 6 && totalBoxItems < 8) {
      $(".onetime_incentive").html(
        "Add " + (8 - totalBoxItems) + " more and pay £5.52 per tube"
      );
    }
    if (totalBoxItems >= 8) {
      $(".onetime_incentive").html(
        '<span style="color:#d34d58">You\'re getting our best discount (15%)</span>'
      );
    }

    // Make button active as product(s) have been selected
    builderHasItems = true;
    document
      .getElementById("addToCartButton")
      .classList.remove("disabled_button");

    // Display number of packs in box
    if (isSubscriptionOrder) {
      if (totalBoxItems >= 4) {
        $("#buildBoxPacksInBox").html(totalBoxItemsContent(totalBoxItems));
        $(".sub_incentive").html(
          '<span style="color:#d34d58">You\'re getting our best discount (20%)</span>'
        );
      } else {
        $("#buildBoxPacksInBox").html(totalBoxItemsContent(totalBoxItems));
        $(".sub_incentive").html(
          "Add " +
            (4 - totalBoxItems) +
            " or more tubes to subscribe & save 20%"
        );
      }
    } else {
      $("#buildBoxPacksInBox").html(totalBoxItemsContent(totalBoxItems));
    }

    // Display total servings in box as a figure
    var servingsCount = totalBoxItems * 12;
    $("#buildBoxServingsInBox.subCount").html(servingsCount);
    $("#buildBoxServingsInBox.oneTimeCount").html(servingsCount);

    //if(isSubscriptionOrder) {
    //$('#buildBoxTotalCost').html('<span class="strike-through">' + parseFloat(totalBoxItems * 20).toLocaleString('en-GB', localeOptions) + '</span> <span class="color-brand-red">' + (parseFloat(buildBoxPrices[totalBoxItems - 1]) * totalBoxItems * 0.8).toLocaleString('en-GB', localeOptions) + '</span>');
    //$('#buildBoxPricePerServing').html('<span class="strike-through">£0.67</span> ' + (parseFloat(buildBoxPrices[totalBoxItems - 1]) / 30 * 0.8).toLocaleString('en-GB', localeOptions));
    //} else {

    if (isSubscriptionOrder) {
      if (totalBoxItems >= 4) {
        console.log("4 items or more!");
        document.getElementById("addToCartButton").classList.remove("hide");
        document.getElementById("preSubButton").classList.add("hide");
        $(".sub-total #buildBoxTotalCost").html(
          '<span class="now-price">' +
            parseFloat(totalBoxItems * 5.19).toLocaleString(
              "en-GB",
              localeOptions
            ) +
            '</span> <span class="was-price">You Saved ' +
            parseFloat(
              6.49 * totalBoxItems - totalBoxItems * 4.31
            ).toLocaleString("en-GB", localeOptions) +
            "</span>"
        );
        $(".sub-total #buildBoxPricePerServing").html(
          '<span class="strike-through">£0.54</span> ' +
            (parseFloat(5.19) / 12).toLocaleString("en-GB", localeOptions)
        );
      } else {
        console.log("not subbed yet");
        document.getElementById("preSubButton").classList.remove("hide");
        document.getElementById("addToCartButton").classList.add("hide");
        $(".sub-total #buildBoxTotalCost").html(
          '<span class="now-price">' +
            parseFloat(totalBoxItems * 5.19).toLocaleString(
              "en-GB",
              localeOptions
            ) +
            '</span> <span class="was-price grey">You Saved £0.00</span>'
        );
        $(".sub-total #buildBoxPricePerServing").html(
          '<span class="strike-through">£0.54</span> ' +
            parseFloat(5.19 / 12).toLocaleString("en-GB", localeOptions)
        );
      }
    } else {
      if (totalBoxItems < 4) {
        console.log("less than 4");
        $(".onetime-total #buildBoxTotalCost").html(
          '<span class="now-price">' +
            (
              parseFloat(buildBoxPrices[totalBoxItems - 1]) * totalBoxItems
            ).toLocaleString("en-GB", localeOptions) +
            '</span> <span class="was-price grey">You Saved £0.00</span>'
        );
        $(".onetime-total #buildBoxPricePerServing").html(
          (parseFloat(buildBoxPrices[totalBoxItems - 1]) / 12).toLocaleString(
            "en-GB",
            localeOptions
          )
        );
      }
      if (totalBoxItems >= 4 && totalBoxItems < 8) {
        console.log("4 to 8");
        $(".onetime-total #buildBoxTotalCost").html(
          '<span class="now-price">' +
            (
              parseFloat(buildBoxPrices[totalBoxItems - 1]) * totalBoxItems
            ).toLocaleString("en-GB", localeOptions) +
            '</span> <span class="was-price">You Saved ' +
            parseFloat(
              6.49 * totalBoxItems -
                buildBoxPrices[totalBoxItems - 1] * totalBoxItems
            ).toLocaleString("en-GB", localeOptions) +
            "</span>"
        );
        $(".onetime-total #buildBoxPricePerServing").html(
          '<span class="strike-through">£0.54</span> ' +
            (parseFloat(buildBoxPrices[totalBoxItems - 1]) / 12).toLocaleString(
              "en-GB",
              localeOptions
            )
        );
      }
      if (totalBoxItems >= 8) {
        console.log("8 or more");
        $(".onetime-total #buildBoxTotalCost").html(
          '<span class="now-price">' +
            (parseFloat(buildBoxPrices[8]) * totalBoxItems).toLocaleString(
              "en-GB",
              localeOptions
            ) +
            '</span> <span class="was-price">You Saved ' +
            parseFloat(
              6.49 * totalBoxItems - buildBoxPrices[8] * totalBoxItems
            ).toLocaleString("en-GB", localeOptions) +
            "</span>"
        );
        $(".onetime-total #buildBoxPricePerServing").html(
          '<span class="strike-through">£0.54</span> ' +
            (parseFloat(buildBoxPrices[8]) / 12).toLocaleString(
              "en-GB",
              localeOptions
            )
        );
      }
    }
    //}

    updateProductIds(totalBoxItems);
  };

  const updateProductIds = (totalBoxItems) => {
    if (totalBoxItems > uniquePrices) {
      totalBoxItems = 8;
    }

    // Loop all the input fields
    $(".build-box__incrementor--input").each(function() {
      console.log("BOX ITEMS " + totalBoxItems);

      let product = $(this).attr("data-product");
      let freq = $("#deliveryFrequency").val();

      var rechargeOne =
        buildBoxProducts[product][parseInt(totalBoxItems)].rechargeOneId;
      var rechargeTwo =
        buildBoxProducts[product][parseInt(totalBoxItems)].rechargeTwoId;
      var rechargeThree =
        buildBoxProducts[product][parseInt(totalBoxItems)].rechargeThreeId;
      var rechargeFour =
        buildBoxProducts[product][parseInt(totalBoxItems)].rechargeFourId;

      if (isSubscriptionOrder) {
        $(this).attr("data-onetime-id", buildBoxProducts[product][1].variantId);

        if (freq == 1) {
          $(this).attr("data-subscription-id", rechargeOne);
        } else if (freq == 2) {
          $(this).attr("data-subscription-id", rechargeTwo);
        } else if (freq == 3) {
          $(this).attr("data-subscription-id", rechargeThree);
        } else {
          $(this).attr("data-subscription-id", rechargeFour);
        }
      } else {
        $(this).attr(
          "data-onetime-id",
          buildBoxProducts[product][parseInt(totalBoxItems)].variantId
        );
      }
    });

    // Event Listener for subscription frequency dropdown
    $("#deliveryFrequency").change(function() {
      console.log("frequency has changed");

      $(".build-box__incrementor--input").each(function() {
        let product = $(this).attr("data-product");
        let freq = $("#deliveryFrequency").val();

        var rechargeOne =
          buildBoxProducts[product][parseInt(totalBoxItems)].rechargeOneId;
        var rechargeTwo =
          buildBoxProducts[product][parseInt(totalBoxItems)].rechargeTwoId;
        var rechargeThree =
          buildBoxProducts[product][parseInt(totalBoxItems)].rechargeThreeId;
        var rechargeFour =
          buildBoxProducts[product][parseInt(totalBoxItems)].rechargeFourId;

        if (isSubscriptionOrder) {
          if (freq == 1) {
            $(this).attr("data-subscription-id", rechargeOne);
          } else if (freq == 2) {
            $(this).attr("data-subscription-id", rechargeTwo);
          } else if (freq == 3) {
            $(this).attr("data-subscription-id", rechargeThree);
          } else {
            $(this).attr("data-subscription-id", rechargeFour);
          }
        }
      });
    });
  };

  // Add to cart button click event listener
  $("#addToCartButton").click(function(e) {
    e.preventDefault();
    console.log(buildBoxProducts);
    //return;

    // Stop everything happening if there's no products selected
    if (!builderHasItems) {
      console.log("nothing in the builder!");
      return;
    }

    // Clear the cart, saves big hassle of having to consider mutliple boxes at different price points in the cart
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: {
        updates: {
          39845937741986: 0,
          39856734765218: 0,
          39856741482658: 0,
          39856746168482: 0,
          39856776118434: 0,
          39845946327202: 0,
          39856744136866: 0,
          39856746692770: 0,
          39856792043682: 0,
          39845939773602: 0,
          39856743219362: 0,
          39856747217058: 0,
        },
      },
      dataType: "json",
      success: function() {
        console.log("Cart cleared");
        addToCartItems = [];
        sendToCartAndMoveAlong(cartQueue);
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log("Error clearing the cart");
      },
    });

    this.classList.add("is-disabled");
    this.innerText = "Adding to cart...";

    // Loop inputs and add up total amount of items in box
    let totalBoxItems = 0;

    $(".build-box__incrementor--input").each(function() {
      let newVal = parseInt($(this).val());
      totalBoxItems = totalBoxItems + newVal;
    });

    let cartQueue = [];

    // Loop each input and add required quantity and variant ID to cart
    $(".build-box__incrementor--input").each(function() {
      let singlePurchaseVariantId = $(this).attr("data-onetime-id");
      let subscriptionVariantId = $(this).attr("data-subscription-id");
      //let variantId;
      let quantity = parseInt($(this).val());
      let product = $(this).attr("data-product");

      console.log(
        "PRODUCT: " +
          product +
          "ONETIME = " +
          singlePurchaseVariantId +
          " // PLAN = " +
          subscriptionVariantId +
          " // QUANTITY = " +
          quantity
      );
      // Assign the relevant variant ID based on whether it's a subscription or single purchase order
      //isSubscriptionOrder ? variantId = subscriptionVariantId : variantId = singlePurchaseVariantId;

      if (quantity > 0) {
        // Build each cart line
        let cartItem = {
          id: singlePurchaseVariantId,
          quantity: quantity,
        };

        //Add extra cart data if item is subscription
        if (isSubscriptionOrder) {
          cartItem.selling_plan = subscriptionVariantId;
          //	const deliveryFrequency = parseInt($("#deliveryFrequency option:selected").val());
          //	cartItem.properties.shipping_interval_frequency = deliveryFrequency;
          //	cartItem.properties.shipping_interval_unit_type = 'weeks';
        }

        // Add cart line to array of complete order
        cartQueue.push(cartItem);
      }
    });

    console.log(cartQueue);

    const sendToCartAndMoveAlong = (cartQueue) => {
      if (cartQueue.length) {
        let cartItem = cartQueue.pop();
        addToCartItems.push(cartItem);
        console.log(cartItem);
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data: cartItem,
          dataType: "json",
          success: function(response) {
            // Call this same function again with the now smaller cart queue array
            sendToCartAndMoveAlong(cartQueue);
          },
          error: function(response) {
            console.log(response);
          },
        });
      } else {
        // Nothing left in the queue, send user to cart page
        //window.location.href = '/cart';
        // Open cart drawer
        setTimeout(() => {
          this.innerText = "Add to cart";
          window.goCart.fetchAndOpenCart(addToCartItems);
        }, 1000);
      }
    };
  });

  $(document).ready(function() {
    let boxCount = 0;

    $(".build-box__incrementor--input").each(function() {
      let iVal = parseInt($(this).val());
      boxCount = boxCount + iVal;
    });
    console.log(
      "VALUE PRE-SELECTED: " + $("input[type=radio][name=purchase-type]").val()
    );
    if ($("input[type=radio][name=purchase-type]").val() == "subscription") {
      isSubscriptionOrder = true;
      if (boxCount < 4) {
        document.getElementById("addToCartButton").classList.add("hide");
        document.getElementById("preSubButton").classList.remove("hide");
      } else {
        document.getElementById("addToCartButton").innerHTML = "Subscribe";
        document.getElementById("preSubButton").classList.add("hide");
        document.getElementById("addToCartButton").classList.remove("hide");
      }
      document
        .getElementById("deliveryFrequencyOptions")
        .classList.remove("hide");
      document.getElementById("buildBox__calc-onetime").classList.add("hide");
      document.getElementById("buildBox__calc-sub").classList.remove("hide");
    } else if (
      $("input[type=radio][name=purchase-type]").val() == "single-purchase"
    ) {
      isSubscriptionOrder = false;
      document.getElementById("addToCartButton").innerHTML = "Add To Cart";
      document.getElementById("deliveryFrequencyOptions").classList.add("hide");
      document
        .getElementById("buildBox__calc-onetime")
        .classList.remove("hide");
      document.getElementById("buildBox__calc-sub").classList.add("hide");
      document.getElementById("preSubButton").classList.add("hide");
      document.getElementById("addToCartButton").classList.remove("hide");
    }
  });

  // Event Listener for radio toggle between subscription & single purchase
  $("input[type=radio][name=purchase-type]").change(function() {
    let boxCount = 0;

    $(".build-box__incrementor--input").each(function() {
      let iVal = parseInt($(this).val());
      boxCount = boxCount + iVal;
    });

    if (this.value == "subscription") {
      isSubscriptionOrder = true;
      if (boxCount < 4) {
        document.getElementById("addToCartButton").classList.add("hide");
        document.getElementById("preSubButton").classList.remove("hide");
      } else {
        document.getElementById("addToCartButton").innerHTML = "Subscribe";
        document.getElementById("preSubButton").classList.add("hide");
        document.getElementById("addToCartButton").classList.remove("hide");
      }
      document
        .getElementById("deliveryFrequencyOptions")
        .classList.remove("hide");
      document.getElementById("buildBox__calc-onetime").classList.add("hide");
      document.getElementById("buildBox__calc-sub").classList.remove("hide");
    } else if (this.value == "single-purchase") {
      isSubscriptionOrder = false;
      document.getElementById("addToCartButton").innerHTML = "Add To Cart";
      document.getElementById("deliveryFrequencyOptions").classList.add("hide");
      document
        .getElementById("buildBox__calc-onetime")
        .classList.remove("hide");
      document.getElementById("buildBox__calc-sub").classList.add("hide");
      document.getElementById("preSubButton").classList.add("hide");
      document.getElementById("addToCartButton").classList.remove("hide");
    }
    updateTotals();
  });
});

$(".build-box__incrementor--container .add-block").on("click", function() {
  console.log("add");
  $(this).toggleClass("add-free");
  $(this)
    .siblings('.build-box__incrementor[data-type="plus"]')
    .click();
  $("#addToCartButton").removeClass("disabled_button");

  let totalBoxItems = 0;

  $(".build-box__incrementor--input").each(function() {
    let newVal = parseInt($(this).val());
    totalBoxItems = totalBoxItems + newVal;
  });

  // Make button active as product(s) have been selected
  builderHasItems = true;
  document.getElementById("addToCartButton").classList.remove("is-disabled");

  // Display total servings in box as a figure
  var servingsCount = totalBoxItems * 12;
  $("#buildBoxServingsInBox.subCount").html(servingsCount);
  $("#buildBoxServingsInBox.oneTimeCount").html(servingsCount);
});
